var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === 1
        ? [
            _c("h3", [
              _c("span", { staticClass: "color-primary" }, [
                _vm._v(_vm._s(_vm.customerName))
              ]),
              _vm._v(" von\n\t\t\t"),
              _c("span", { staticClass: "color-primary" }, [
                _vm._v(_vm._s(_vm.companyName))
              ]),
              _vm._v(" hat dir einen Terminvorschlag zur Position\n\t\t\t"),
              _c("span", { staticClass: "color-primary" }, [
                _vm._v(_vm._s(_vm.jobProfileInfo))
              ]),
              _vm._v(" gesendet.\n\t\t")
            ]),
            _vm._v(" "),
            _vm.appointment
              ? _c(
                  "div",
                  [
                    _c("AppointmentInfos", {
                      attrs: { appointment: _vm.appointment, type: "applicant" }
                    }),
                    _vm._v(" "),
                    _c("DateChoiceOrProposal", {
                      attrs: {
                        appointment: _vm.appointment,
                        type: "applicant"
                      },
                      model: {
                        value: _vm.dateChoiceOrProposalData,
                        callback: function($$v) {
                          _vm.dateChoiceOrProposalData = $$v
                        },
                        expression: "dateChoiceOrProposalData"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("PopUpActions", {
              attrs: {
                "with-back": false,
                "continue-text": "Weiter",
                "continue-disabled": !_vm.dateChoiceOrProposalDataValid
              },
              on: {
                continue: function($event) {
                  _vm.step = 2
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 2
        ? [
            _vm.dateChoiceOrProposalData.datesNotPossible ||
            _vm.dateChoiceOrProposalData.allDatesPastDue
              ? [
                  _vm.isCounterProposalTypeSuggestions
                    ? [
                        _vm.dateChoiceOrProposalData.counterProposalDates
                          .length > 0
                          ? _c("JonInfo", {
                              staticClass: "mt-0 mb-2",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "message",
                                    fn: function() {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "Bitte überprüfe deine vorgeschlagenen Termine auf Korrektheit:"
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                72307890
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.dateChoiceOrProposalData.counterProposalDates,
                          function(date) {
                            return _c(
                              "div",
                              { key: date.id, class: ["font-weight-bold"] },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("fullDateTimeByDateAndTime")(date)
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          }
                        )
                      ]
                    : _c("div", [
                        _vm._v(
                          "Der Kunde wird informiert dass er dir neue Terminvorschläge schicken soll."
                        )
                      ])
                ]
              : [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm._f("fullDateTime")(
                          _vm.dateChoiceOrProposalData.chosenDate.timeStamp
                        )
                      ) + " bestätigen"
                    )
                  ]),
                  _vm._v(" "),
                  _c("JonInfo", {
                    staticClass: "mt-3",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "message",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n\t\t\t\t\tDu erhältst noch rechtzeitig allfällige Details, die du vor dem Termin benötigst."
                              ),
                              _c("br"),
                              _vm._v(
                                '\n\t\t\t\t\tWenn du "Termin bestätigen" drückst, erhält\n\t\t\t\t\t'
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "font-weight-extra-bold color-primary"
                                },
                                [_vm._v(_vm._s(_vm.customerName))]
                              ),
                              _vm._v(
                                " eine Nachricht,\n\t\t\t\t\tdass du den Termin angenommen hast."
                              ),
                              _c("br"),
                              _vm._v(
                                '\n\t\t\t\t\tAlle Termine findest du im Bereich "Deine Job-Termine", welche dort auch bearbeitet werden können.\n\t\t\t\t'
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3925197526
                    )
                  })
                ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("PopUpActions", {
                  attrs: {
                    "continue-text": _vm.step2ContinueText,
                    "continue-disabled": _vm.sendingRequest,
                    "continue-loading": _vm.sendingRequest
                  },
                  on: {
                    back: function($event) {
                      _vm.step = 1
                    },
                    continue: _vm.continueOnStep2
                  }
                })
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }